import { render, staticRenderFns } from "./productUpdate.vue?vue&type=template&id=7bed8214"
import script from "./productUpdate.vue?vue&type=script&lang=js"
export * from "./productUpdate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports